import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const BottomNavBar: React.FC = () => {
  const { currentUser } = useAuth();
  const location = useLocation();

  const profilePath = currentUser?.isContractor ? '/contractor-profile' : '/profile';

  // Profile tab is active on both profile routes
  const profileIsActive =
    location.pathname === '/profile' || location.pathname === '/contractor-profile';

  const navItems = [
    { to: '/', icon: 'home', label: 'Home', end: true },
    currentUser?.isContractor
      ? { to: '/jobs', icon: 'work', label: 'Jobs' }
      : { to: '/contractors', icon: 'search', label: 'Search' },
    currentUser
      ? { to: '/my-jobs', icon: 'work_history', label: 'My Jobs' }
      : { to: '/jobs', icon: 'work', label: 'Jobs' },
    { to: '/messages', icon: 'chat_bubble', label: 'Messages' },
  ];

  const activeClass = 'flex flex-col items-center justify-center bg-secondary-container dark:bg-secondary text-on-secondary-container dark:text-on-secondary rounded-2xl px-4 py-1 active:scale-90 transition-all duration-200';
  const inactiveClass = 'flex flex-col items-center justify-center text-on-surface-variant dark:text-outline-variant hover:text-secondary dark:hover:text-secondary-fixed-dim active:scale-90 transition-all duration-200';

  return (
    <nav className="fixed bottom-0 left-0 w-full z-50 bg-surface dark:bg-on-background border-t border-outline-variant dark:border-outline shadow-lg flex justify-around items-center px-4 py-2 rounded-t-xl md:hidden">
      {navItems.map(({ to, icon, label, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) => isActive ? activeClass : inactiveClass}
        >
          {({ isActive }) => (
            <>
              <span
                className="material-symbols-outlined"
                data-icon={icon}
                style={isActive ? { fontVariationSettings: "'FILL' 1" } : undefined}
              >
                {icon}
              </span>
              <span className="font-label-md text-label-md">{label}</span>
            </>
          )}
        </NavLink>
      ))}

      {/* Profile tab - destination depends on role */}
      <NavLink
        to={profilePath}
        className={profileIsActive ? activeClass : inactiveClass}
      >
        <span
          className="material-symbols-outlined"
          data-icon="person"
          style={profileIsActive ? { fontVariationSettings: "'FILL' 1" } : undefined}
        >
          person
        </span>
        <span className="font-label-md text-label-md">Profile</span>
      </NavLink>
    </nav>
  );
};

export default BottomNavBar;
